import React from 'react';

import {PortfolioUtils} from '../../../../../../../utils/utils';
import _ from 'lodash';
import useStyles from '../styles';
import ChartSectionBordered from "../../../../../components_v2/ChartSectionBordered/ChartSectionBordered";
import {StructureTable} from "../../../../../components_v2/StructureTable/StructureTable";
import {
  CustomerDashboardNoDataPlaceholder
} from "../../../../../../FactSheetsPage/components/NoDataPlaceholder";
import {portfolioStructurePropsAreEquals} from '../utils';

const SyntheticRiskRewardChart = React.memo((props) => {
  const {
    dashboardData,
    preferredColor,
    expanded,
    onExpanded,
  } = props;

  const classes = useStyles();

  const portfolioStructure = dashboardData && dashboardData.portfolio_structure;

  let data = [];
  if (portfolioStructure) {
    data = PortfolioUtils.getPortfolioRiskIndicators(portfolioStructure)
  }
  const hasData = !_.isEmpty(data);

  return (
    <ChartSectionBordered
      title={(
        <>
          <b>Risikoverteilung</b>
          {hasData && (
            <><span className={classes.subtitle}>(Durchschnitt: { portfolioStructure && portfolioStructure['by_srri_average'] })</span></>
          )}
        </>
      )}
      expanded={expanded}
      onExpanded={onExpanded}
      skipContentPadding={hasData}
      content={(
        <>
          {hasData ? (
            <StructureTable
              series={data || []}
              preferredColor={preferredColor}
            />
          ) : (
            <CustomerDashboardNoDataPlaceholder />
          )}
        </>
      )}
    />
  )
}, portfolioStructurePropsAreEquals);

export default SyntheticRiskRewardChart;
